import React from 'react';
import { Category } from '../../types';
import Badge from '../common/Badge';

interface CategoryFilterProps {
  categories: Category[];
  selectedCategory: number | null;
  onSelectCategory: (categoryId: number | null) => void;
  loading?: boolean;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  selectedCategory,
  onSelectCategory,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-20 mb-3"></div>
        <div className="space-y-2">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-8 bg-gray-200 rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <h3 className="text-sm font-medium text-gray-900 mb-3">카테고리</h3>
      
      <div className="space-y-1">
        <button
          onClick={() => onSelectCategory(null)}
          className={`
            w-full text-left px-3 py-2 rounded-md text-sm transition-colors
            ${selectedCategory === null
              ? 'bg-primary-100 text-primary-800 font-medium'
              : 'text-gray-700 hover:bg-gray-100'
            }
          `}
        >
          <span className="flex items-center justify-between">
            전체
            <Badge variant="secondary" size="sm">
              {categories.reduce((sum, cat) => sum + (cat.prompt_count || 0), 0)}
            </Badge>
          </span>
        </button>

        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onSelectCategory(category.id)}
            className={`
              w-full text-left px-3 py-2 rounded-md text-sm transition-colors
              ${selectedCategory === category.id
                ? 'bg-primary-100 text-primary-800 font-medium'
                : 'text-gray-700 hover:bg-gray-100'
              }
            `}
          >
            <span className="flex items-center justify-between">
              <span className="truncate">{category.name}</span>
              {category.prompt_count !== undefined && (
                <Badge variant="secondary" size="sm">
                  {category.prompt_count}
                </Badge>
              )}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;